// extracted by mini-css-extract-plugin
export var wrapper = "ClientsSwiper-module--wrapper--14O3-";
export var swiper = "ClientsSwiper-module--swiper--2tqLv";
export var swiper__slide = "ClientsSwiper-module--swiper__slide--30ES5";
export var swiper__slide__title = "ClientsSwiper-module--swiper__slide__title--fp3zs";